import { router } from './router';
import { NAME } from './constants';

export const NdObjednavkaZakazka = {
	name: NAME,
	router,
};
